/**
 * Create React App public env helpers.
 * Production builds fail loudly when required vars are missing (no silent Sepolia/localhost fallbacks).
 */

export function isProductionBuild() {
  return process.env.NODE_ENV === "production";
}

/**
 * @param {string} name
 * @param {string} [devFallback] Used only when NODE_ENV !== "production"
 */
export function requireEnvString(name, devFallback) {
  const trimmed = String(process.env[name] ?? "").trim();
  if (trimmed) return trimmed;
  if (isProductionBuild()) {
    throw new Error(
      `Missing required environment variable ${name} for production builds. See .env.example.`
    );
  }
  if (devFallback !== undefined) return devFallback;
  return "";
}

/**
 * @param {string} name
 * @param {number} [devFallback]
 */
export function requireEnvChainId(name, devFallback) {
  const raw = String(process.env[name] ?? "").trim();
  if (!raw) {
    if (isProductionBuild()) {
      throw new Error(
        `Missing required environment variable ${name} for production builds. See .env.example.`
      );
    }
    if (devFallback !== undefined) return devFallback;
    return NaN;
  }
  const n = parseInt(raw, 10);
  if (!Number.isFinite(n)) {
    throw new Error(`Invalid ${name}: must be a numeric chain id.`);
  }
  return n;
}

/** Sepolia testnet — dev fallback only; never assumed in production. */
export const SEPOLIA_CHAIN_ID = 11155111;
